module.exports = __webpack_public_path__ + "assets/atomic-bomb.dac4ba4c3a0db5ffe77060716530da20.svg";